import { render } from "./Skill.vue?vue&type=template&id=4b9c65b6"
import script from "./Skill.vue?vue&type=script&lang=js"
export * from "./Skill.vue?vue&type=script&lang=js"

import "./Skill.vue?vue&type=style&index=0&id=4b9c65b6&lang=css"

import exportComponent from "C:\\Users\\4827\\Projects\\Personal\\github-cv\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLinearProgress});
